const headline = {
  label: 'Headline',
  name: 'headline',
  component: 'text',
  defaultValue: 'Experience Best-in-Class Filtration',
};

export default headline;
